import { render, staticRenderFns } from "./IntegracaoModal.vue?vue&type=template&id=2df895d4&"
import script from "./IntegracaoModal.vue?vue&type=script&lang=js&"
export * from "./IntegracaoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports